import React from "react";
import styles from "./articles.module.css";

import pdfIcon from "../../../files/icons/pdfIcon.png";
import AvtomatSistTeploEnerOAOMosenergo from "../../../files/documents/AvtomatSistTeploEnerOAOMosenergo.pdf";
import seminar2 from "../../../files/documents/seminar_2.pdf";
import seminar_program3 from "../../../files/documents/seminar_program_3.pdf";
import participants_list4 from "../../../files/documents/participants_list_4.pdf";
import khilkovsky_1_5 from "../../../files/documents/khilkovsky_1_5.pdf";
import khilkovsky_2_6 from "../../../files/documents/khilkovsky_2_6.pdf";
import trofimov_8 from "../../../files/documents/trofimov_8.pdf";


class ArticlesSlide extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div style={{ fontWeight: "600" }}>
          В журнале "Энергонадзор и энергобезопасность" (номер 2 от 2010г.)
          вышла статья
        </div>
        <div style={{ paddingTop: "1%" }} />
        <div
          className={styles.pdfContainer}
          style={{
            display: "table-cell",
            verticalAlign: "middle"
          }}
        >
          <img
            src={pdfIcon}
            alt="acrobat icon"
            style={{
              width: "2.4em",
              height: "auto"
            }}
          />
        </div>
        <div
          className={styles.pdfContainer}
          style={{
            display: "table-cell",
            paddingLeft: "8px",
            paddingTop: "2%"
          }}
        >
          <a
            href={AvtomatSistTeploEnerOAOMosenergo}
            donwload="Статья - Автоматизированные системы учета тепловой энергии ОАО Мосэнерго"
            target="_blank"
            rel="noopener noreferrer"
          >
            Автоматизированные системы учета тепловой энергии в ОАО "Мосэнерго"
          </a>
          <br />
          (Э.В. Голиков, Ю.Н. Шандора, В.Н. Игнатов, М.О. Фикс, К.Б.
          Хильковский, И.Е. Трофимов).
        </div>

        <div style={{ paddingTop: "3%" }} />
        <div style={{ fontWeight: "600" }}>
          ООО «Теплоинформ» приняло участие в Международной презентации проекта
          «ПРОГРАММА РЕГИОНАЛЬНОГО ИННОВАЦИОННОГО СОТРУДНИЧЕСТВА В ОБЛАСТИ
          ЭНЕРГОЭФФЕКТИВНОСТИ И ЭНЕРГОСБЕРЕЖЕНИЯ», прошедшей 17-18 июня 2010г. в
          г. Москва.
        </div>
        <div style={{ paddingTop: "1%" }} />
        <div
          className={styles.pdfContainer}
          style={{ display: "table-cell", verticalAlign: "middle" }}
        >
          <img
            src={pdfIcon}
            alt="acrobat icon"
            style={{
              width: "2.4em",
              height: "auto"
            }}
          />
        </div>
        <div
          className={styles.pdfContainer}
          style={{
            display: "table-cell",
            verticalAlign: "middle",
            color: "#f30707",
            paddingLeft: "8px"
          }}
        >
          <a
            href={seminar2}
            donwload="Трофимов И.Е. Инновационные АСКУЭ - основа энергосбережения"
            target="_blank"
            rel="noopener noreferrer"
          >
            Трофимов И.Е. Инновационные АСКУЭ - основа энергосбережения.
          </a>
        </div>

        <div style={{ paddingTop: "3%" }} />
        <div style={{ fontWeight: "600" }}>
          12 ноября 2009г. в Москве состоялся семинар «Диспетчеризация Учёта и
          Контроля тепловой энергии, отпущенной абонентам и сопутствующие
          задачи».
        </div>

        <div style={{ paddingTop: "1%" }} />
        <div style={{ display: "table" }}>
          <div style={{ display: "table-row", verticalAlign: "middle" }}>
            <div
              className={styles.pdfContainer}
              style={{ display: "table-cell" }}
            >
              <img
                src={pdfIcon}
                alt="acrobat icon"
                style={{
                  width: "2.4em",
                  height: "auto"
                }}
              />
            </div>
            <div
              style={{
                display: "table-cell",
                verticalAlign: "middle",
                color: "#f30707",
                paddingLeft: "8px"
              }}
            >
              <a
                href={seminar_program3}
                donwload="Программа семинара"
                target="_blank"
                rel="noopener noreferrer"
              >
                Программа семинара.
              </a>
            </div>
          </div>
          <div style={{ display: "table-row", verticalAlign: "middle" }}>
            <div
              className={styles.pdfContainer}
              style={{ display: "table-cell" }}
            >
              <img
                src={pdfIcon}
                alt="acrobat icon"
                style={{
                  width: "2.4em",
                  height: "auto"
                }}
              />
            </div>
            <div
              style={{
                display: "table-cell",
                verticalAlign: "middle",
                color: "#f30707",
                paddingLeft: "8px"
              }}
            >
              <a
                href={participants_list4}
                donwload="Список участников семинара"
                target="_blank"
                rel="noopener noreferrer"
              >
                Список участников семинара.
              </a>
            </div>
          </div>
          <div style={{ display: "table-row", verticalAlign: "middle" }}>
            <div
              className={styles.pdfContainer}
              style={{ display: "table-cell" }}
            >
              <img
                src={pdfIcon}
                alt="acrobat icon"
                style={{
                  width: "2.4em",
                  height: "auto"
                }}
              />
            </div>
            <div
              style={{
                display: "table-cell",
                verticalAlign: "middle",
                color: "#f30707",
                paddingLeft: "8px"
              }}
            >
              <a
                href={khilkovsky_1_5}
                donwload="Хильковский К.Б. Опыт эксплуатации «Автоматизированной системы
                удалённого сбора и контроля данных с теплосчётчиков» (АСКУ Аб)
                ОАО «Московская теплосетевая компания»; ТЭЦ-3, г.Тверь."
                target="_blank"
                rel="noopener noreferrer"
              >
                Хильковский К.Б. Опыт эксплуатации «Автоматизированной системы
                удалённого сбора и контроля данных с теплосчётчиков» (АСКУ Аб)
                ОАО «Московская теплосетевая компания»; ТЭЦ-3, г.Тверь.
              </a>
            </div>
          </div>
          <div style={{ display: "table-row", verticalAlign: "middle" }}>
            <div
              className={styles.pdfContainer}
              style={{ display: "table-cell" }}
            >
              <img
                src={pdfIcon}
                alt="acrobat icon"
                style={{
                  width: "2.4em",
                  height: "auto"
                }}
              />
            </div>
            <div
              style={{
                display: "table-cell",
                verticalAlign: "middle",
                color: "#f30707",
                paddingLeft: "8px"
              }}
            >
              <a
                href={khilkovsky_2_6}
                donwload="Хильковский К.Б. Об удалённом доступе к данным и оповещении о
                нештатных ситуациях при отсутствии сетевого электропитания."
                target="_blank"
                rel="noopener noreferrer"
              >
                Хильковский К.Б. Об удалённом доступе к данным и оповещении о
                нештатных ситуациях при отсутствии сетевого электропитания.
              </a>
            </div>
          </div>

          <div style={{ display: "table-row", verticalAlign: "middle" }}>
            <div
              className={styles.pdfContainer}
              style={{ display: "table-cell" }}
            >
              <img
                src={pdfIcon}
                alt="acrobat icon"
                style={{
                  width: "2.4em",
                  height: "auto"
                }}
              />
            </div>
            <div
              style={{
                display: "table-cell",
                verticalAlign: "middle",
                color: "#f30707",
                paddingLeft: "8px"
              }}
            >
              <a
                href={trofimov_8}
                donwload="Трофимов И.Е. Новые функциональные возможности Интернет-службы «Теплоинформ»"
                target="_blank"
                rel="noopener noreferrer"
              >
                Трофимов И.Е. Новые функциональные возможности Интернет-службы
                «Теплоинформ»
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ArticlesSlide;
